import React from 'react';
import { FaRocket, FaShieldAlt, FaChartLine, FaUsers } from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: 'Automate Repetitive Tasks',
      subtitle: 'Free Your Teams to Focus on What Matters',
      description: 'Streamline your operations by automating manual, time-consuming tasks. Enable faster, more accurate workflows, reducing costs and increasing efficiency.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Challenge Conventional Constraints',
      subtitle: 'Break Barriers and Explore New Possibilities',
      description: 'Empower your business to tackle challenges once thought impossible. From optimizing processes to improving decision-making, expand your capabilities.'
    },
    {
      icon: <FaChartLine />,
      title: 'Scale Operations for Growth',
      subtitle: 'Adapt and Expand with Ease',
      description: 'Leverage innovative solutions to create scalable systems that grow with your business. Enable seamless expansion without compromising efficiency.'
    },
    {
      icon: <FaUsers />,
      title: 'Enable Ethical Innovation',
      subtitle: 'Build Trust While Driving Progress',
      description: 'Harness technology responsibly with transparency and fairness. Ensure your systems are ethical and inclusive while maintaining accountability.'
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <h4>{feature.subtitle}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 